<template>
    <v-row class="goods-tabs">
        <v-col cols="12" lg="6" class="ma-n4" order-lg="1">
            <v-tabs hide-slider :show-arrows="false" v-model="tab">
                <v-tab v-for="(item, index) in items" :key="index">
                    <div class="goods-tabs__title">
                        {{ item.title }}
                    </div>
                </v-tab>
            </v-tabs>
        </v-col>
        <v-col cols="12" lg="6">
            <v-tabs-items v-model="tab">
                <v-tab-item v-for="(item, index) in items" :key="index" eager>
                    <div class="border-radius-16 overflow-hidden">
                        <v-img :src="item.image" eager alt="" />
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data() {
        return {
            tab: null,

            items: [
                {
                    title: "생리대",
                    image: "/images/guide/goods/goods-1.jpg",
                },
                {
                    title: "의류, 잡화",
                    image: "/images/guide/goods/goods-2.jpg",
                },
                {
                    title: "화장품",
                    image: "/images/guide/goods/goods-3.jpg",
                },
                {
                    title: "생활용품",
                    image: "/images/guide/goods/goods-4.jpg",
                },
                {
                    title: "가전제품",
                    image: "/images/guide/goods/goods-5.jpg",
                },
                {
                    title: "유아용품",
                    image: "/images/guide/goods/goods-6.jpg",
                },
                {
                    title: "건강기능식품 (영양제/비타민)",
                    image: "/images/guide/goods/goods-7.jpg",
                },
                {
                    title: "쌀",
                    image: "/images/guide/goods/goods-8.jpg",
                },
                {
                    title: "식품",
                    image: "/images/guide/goods/goods-9.jpg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.goods-tabs {
    .v-tabs {
        overflow: visible;
        height: 100%;
        min-height: 160px;
        ::v-deep(.v-tabs-bar) {
            height: 100%;
        }
        ::v-deep(.v-slide-group__content) {
            flex-wrap: wrap;
            width: 100%;
        }
        .v-tab {
            height: calc(100% / 3);
            flex-basis: calc(100% / 3);
            position: relative;
            background-color: transparent;
            .goods-tabs__title {
                color: #111;
                font-weight: 700;
                font-size: 12px;
                word-break: keep-all;
            }
            &::after {
                content: "";
                width: calc(100% - 8px);
                height: calc(100% - 8px);
                position: absolute;
                background-color: #fafafa;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: -1;
                border-radius: 12px;
            }
            &--active {
                .goods-tabs__title {
                    color: #fff;
                }
                &::after {
                    background-color: var(--v-primary-base);
                }
            }
        }
    }
    .v-tabs-items {
        position: relative;
        &::before {
            content: "";
            position: absolute;
            width: 100vw;
            height: 100%;
            bottom: -24px;
            right: 24px;
            background-color: var(--v-primary-lighten4);
            border-radius: 16px;
        }
    }
}
@media (min-width: 1024px) {
    .goods-tabs {
        .v-tabs-items {
            &::before {
                top: -50px;
                right: 50px;
            }
        }
        .v-tabs {
            .v-tab {
                &::after {
                    border-radius: 16px;
                }
                .goods-tabs__title {
                    font-size: 24px;
                }
            }
        }
    }
}
</style>